const comMain = () => {
  const jsComSecMain = (document.getElementById("jsComSecMain") != null);
  if (jsComSecMain) {



    let sW = window.innerWidth;
    let sH = window.innerHeight;

    let comSecMain = document.getElementById('jsComSecMain');

    let imgBox = comSecMain.querySelector('.js-img-box');
    let copyBox = comSecMain.querySelector('.js-copy-box');


    gsap.set(copyBox, {
      opacity: 0,
      filter: "blur(10px)",
    })
    gsap.to(copyBox, {
      opacity: 1,
      filter: "blur(0px)",
      duration: 2,
      ease: "power3.inOut",
    }, 0.5)


    gsap.set(imgBox, {
      clipPath: 'polygon(0 0, 0% 0, 0% 100%, 0% 100%)',
    })
    gsap.to(imgBox, {
      clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0% 100%)',
      duration: 2,
      ease: "power3.inOut",
    }, 2)


    gsap.to(copyBox, {
      color: "#fff",
      duration: 2,
      ease: "power3.inOut",
    }, 2)



  }
};
export default comMain;